module.exports = __webpack_public_path__ + "static/sponsorship_img-07-a@2x-2a9cc9aba3b13828cee74a6effeb8e7a.jpg";